import React, { Component } from 'react';
import axios from 'axios';

import classes from './UserProfile.module.css';
import PersonRounded from '@material-ui/icons/PersonRounded';
import {Button} from "@material-ui/core";
import apiUrl from "../../shared/config";
import GroupManagement from "./GroupManagement/GroupManagement";


class UserProfile extends Component {

    state = {
        user: {
            user_id: null,
            first_name: 'Not Specified',
            last_name: 'Not Specified',
            display_name: 'Anonymous',
            user_contact_email: 'Private',
            groups: [
                // {
                //     group_id: null,
                //     group_manager: 0,
                //     group_name: '',
                //     group_type_name: '',
                //     group_type_description: '',
                //     group_user_type_name: '',
                //     group_user_type_description: ''
                // }
            ]
        }
    };

    componentDidMount() {
        if (this.props.account_id ) {
            axios.get(apiUrl +'Users/getUserByAccountId?account_id=' + this.props.account_id + "&token=" + this.props.token)
                .then(response => {
                    this.setState({user: response.data});
                });
        }
        else if (this.state.user && this.props.account_id === null) {
            this.setState({
                "user": {
                    "user_id": null,
                    "first_name": "",
                    "last_name": "",
                    "display_name": "",
                    "user_contact_email": "",
                    "groups": []
                }
            });
        }
    }

    render() {
        //const user_jsx = (<div>{this.state.user.first_name} {this.state.user.last_name}</div>);

        const groups_jsx = this.state.user.groups.map( group => {
            const manager_jsx = group.group_manager ? (<div className={classes.UserLabel}>Group Manager — </div>) : '';
            //const group_type_name = (group.group_type_name ? group.group_type_name.toLowerCase() : '');
            //const group_text = group.group_id ? group.group_user_type_name + member_text +' the '+ group_type_name +' '+ group.group_name +'.' : '';
            const group_members_jsx = group.group_manager ? (
                <div className={classes.UserItem}>
                    <div className={classes.UserLabel}>Group Members:</div>
                    <div className={classes.UserContent}>
                        <GroupManagement
                            account_id = {this.props.account_id}
                            group_id = {group.group_id}
                        />
                    </div>
                </div>
            ) : '';

            const group_jsx = (
                <div className={classes.GroupInfoBlock} key={group.group_id}>
                    <div className={classes.UserItem}>
                        <div className={classes.UserLabel}>Group Name:</div>
                        <div className={classes.UserContent}>{group.group_name}</div>
                    </div>
                    <div className={classes.UserItem}>
                        <div className={classes.UserLabel}>Group Type:</div>
                        <div className={classes.UserContent}>{group.group_type_name}</div>
                    </div>
                    <div className={classes.UserItem}>
                        <div className={classes.UserLabel}>Group Role:</div>
                        {manager_jsx}
                        <div className={classes.UserContent}>{group.group_user_type_name}</div>
                    </div>
                    {group_members_jsx}
                </div>
            );

            return group_jsx;
        });


        return (
                <div className={'card '+ classes.UserCard}>
                    <h4 className="card-header"><PersonRounded />{this.state.user.display_name}</h4>
                    <div className="card-body">
                        <div className="cardText">
                            <div className={classes.UserItem}>
                                <div className={classes.SectionLabel}>USER PROFILE:</div>
                            </div>
                            <div className={classes.UserItem}>
                                <div className={classes.UserLabel}>Display Name:</div>
                                <div className={classes.UserContent}>
                                    {this.state.user.display_name}
                                </div>
                            </div>
                            <div className={classes.UserItem}>
                                <div className={classes.UserLabel}>First Name:</div>
                                <div className={classes.UserContent}>{this.state.user.first_name}</div>
                            </div>
                            <div className={classes.UserItem}>
                                <div className={classes.UserLabel}>Last Name:</div>
                                <div className={classes.UserContent}>{this.state.user.last_name}</div>
                            </div>
                            <div className={classes.UserItem}>
                                <div className={classes.UserLabel}>Contact Email:</div>
                                <div className={classes.UserContent}>{this.state.user.user_contact_email}</div>
                            </div>
                            <div className={classes.UserItem}>
                                <div className={classes.SectionLabel}>GROUPS:</div>
                            </div>
                            {groups_jsx}

                            <Button onClick={this.props.editUser}>Edit</Button>
                        </div>
                    </div>
                </div>
        );
    }
}

export default UserProfile;